import React, { useEffect, useState, useRef, createRef } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import UserService from "../../services/UserService.js";
import mmxlogo from "../../Assets/Images/logo.webp"
import AuthService from "../../services/AuthService.js"
const { REACT_APP_REDIRECT_URI } = process.env;

function Navbar3() {
  const usernameRef = useRef();
  const passwordRef = useRef();
  const agreementRef = useRef();
  const isLoggedIn = UserService.isLoggedIn();
  const username = UserService.getUsername()?.toUpperCase();
  const location = useLocation();
  const [showBrandOption, setShowBrandOption] = useState(false)
  const [primaryTo, setPrimaryTo] = useState('')
  const [currentIndex, setCurrentIndex] = useState('')
  const navigate = useNavigate()

  if (location.pathname === '/') { return null };

  if (location.pathname === '/dashboard') {
    return (
      <nav className="navbar navbar-expand-sm navbar-light bg-white shadow-sm sticky-top" style={{ zIndex: 4 }}>
        <div className="container-fluid">
          <a className="navbar-brand" href="/">
            <img src={mmxlogo} style={{ height: '50px' }} alt="Logo" />
          </a>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarContent"
            aria-controls="navbarContent"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>
          <div className="collapse navbar-collapse" id="navbarContent">
            <ul className="navbar-nav ms-auto align-items-center">
              <li className="nav-item me-3">
                <i className="fa fa-bell fs-4 text-dark"></i>
              </li>

              {!isLoggedIn && (
                <>
                  <li className="nav-item me-2">
                    <button
                      className="btn  px-4 rounded-pill btngreentheme fw-bold"
                      onClick={() =>
                        UserService.doLogin({
                          redirectUri: `${REACT_APP_REDIRECT_URI}/dashboard`,
                        })
                      }
                    >
                      Login <i className="fas fa-sign-in-alt"></i>
                    </button>
                  </li>
                  {/* <li className="nav-item">
                    <button
                      className="btn btn-success rounded-pill px-4 fw-bold fs-5"
                      onClick={() => UserService.doSignUp()}
                    >
                      SignUp <i className="fas fa-user-plus ms-1"></i>
                    </button> 
                  </li>*/}
                </>
              )}

              {isLoggedIn && (
                <li className="nav-item dropdown ms-3">
                  <div className="d-flex align-items-center dropdown-toggle" data-bs-toggle="dropdown" role="button">
                    <svg xmlns="http://www.w3.org/2000/svg" width="36" height="36" viewBox="0 0 23 23" fill="#0d0d0dff">
                      <path d="M15.71 12.71a6 6 0 1 0-7.42 0a10 10 0 0 0-6.22 8.18a1 1 0 0 0 2 .22a8 8 0 0 1 15.9 0a1 1 0 0 0 1 .89h.11a1 1 0 0 0 .88-1.1a10 10 0 0 0-6.25-8.19M12 12a4 4 0 1 1 4-4a4 4 0 0 1-4 4"></path>
                    </svg>
                    <div className="ms-2 text-dark">
                      <div className="fw-bold">Welcome to Revenue Radar</div>
                      <div className="d-flex justify-content-between align-items-center fw-medium">
                        <span>{username}</span>
                      </div>
                    </div>
                  </div>
                  <ul className="dropdown-menu dropdown-menu-end mt-2">
                    <li>
                      <button
                        className="dropdown-item text-dark"
                        onClick={() => {
                          UserService.doLogout({ redirectUri: `${REACT_APP_REDIRECT_URI}` });
                        }}
                      >
                        Logout <i className="fas fa-sign-out-alt"></i>
                      </button>
                    </li>
                  </ul>
                </li>
              )}
            </ul>
          </div>
        </div>
      </nav >
    )
  }

  const navItems = [
    { to: '/dashboard', labelTop: 'Dashboard', labelBottom: 'board' },
    { to: '/refreshmodel', labelTop: 'Refresh Model', labelBottom: 'Model' },
    { to: '/modelperformance', labelTop: 'Model Performance', labelBottom: 'Performance' },
    { to: '/marketanalysis', labelTop: 'Market Analysis', labelBottom: 'Analysis' },
    { to: '/brandanalysis', labelTop: 'Brand Analysis', labelBottom: 'Analysis' },
    { to: '/simulator', labelTop: 'Scenario Planner', labelBottom: 'Planner' },
    { to: '/optimizer', labelTop: 'Optimized Spends', labelBottom: 'Spends' },
    { to: '/savedscenarios', labelTop: 'Saved Scenarios', labelBottom: 'Scenarios' },
    { to: '/savedreports', labelTop: 'Saved Reports', labelBottom: 'Reports' },
  ];
  const isActive = (path) => location.pathname === path || location.pathname === `/atta${path.replace('/', '')}`;

  const submitLogin = () => {
    try {
      if (agreementRef.current.checked) {
        AuthService.login({ username: usernameRef.current.value, password: passwordRef.current.value });
        console.log('success', 'Logged in Successfully', 'Logged in Successfully');
      }
      else {
        console.log('danger', 'Please accept Agreement', 'Terms and Conditions');
      }

    } catch (error) {
      console.log('danger', 'Please c Agreement', 'Terms and Conditions');
    }
  }

  const checkToLink = (to, index) => {
    if (to !== '/dashboard' && to !== '/modelperformance' && to !== '/savedreports' && to !== '/refreshmodel') {
      if (showBrandOption && currentIndex === index) {
        // if same nav clicked → toggle
        setShowBrandOption(false);
      } else {
        // if different nav clicked → switch dropdown to new one
        setShowBrandOption(true);
        setCurrentIndex(index);
      }
    } else {
      setShowBrandOption(false); // also close dropdown when going to dashboard/modelperformance/savedreports
      window.location.href = to;
    }
  };


  const handleBrandOptionToLink = (to, brandOption) => {
    if (brandOption === "atta") {
      if (to === "/marketanalysis") window.location.href = "/attamarketanalysis";
      else if (to === "/brandanalysis") window.location.href = "/attabrandanalysis";
      else if (to === "/simulator") window.location.href = "/attasimulator";
      else if (to === "/optimizer") window.location.href = "/attaoptimizer";
      else if (to === "/savedscenarios") window.location.href = "/attasavedscenarios";
    } else {
      window.location.href = to;
    }
  };


  return (
    <>
      <div className="modal-overlay"></div>

      <div id="login" className="modal">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body modal-body1">
              <div className="motit d-flex justify-content-end">
                <button type="button" className="close">
                  <iconify-icon icon="material-symbols:close"></iconify-icon>
                </button>
              </div>
              <div className="loginwhitebg px-4 py-3">
                <div className="text-center mb-3">
                  <div className="loginiconbg">
                    <img src="/Assets/Images/loginicon1.webp" className="img-fluid" alt="Revenue Radar" />
                    <br />Login
                  </div>
                </div>
                <div className="form-group my-2">
                  <input ref={usernameRef} type="text" className="form-control" placeholder="Enter Your Username" />
                </div>
                <div className="form-group my-2">
                  <input ref={passwordRef} type="password" className="form-control" placeholder="Enter Your Password" />
                </div>
                <div className="text-end mb-2">
                  <a href="#">Forgot Password?</a>
                </div>
                <div className="form-check mb-2">
                  <input ref={agreementRef} type="checkbox" className="form-check-input" id="agreement" />
                  <label className="form-check-label" htmlFor="agreement">
                    I agree to the Terms of Service and Privacy Policy.
                  </label>
                </div>
                <div className="text-center my-2">
                  <button onClick={submitLogin} className="btn btn-success w-100">
                    Login <iconify-icon icon="iconamoon:arrow-right-2-bold"></iconify-icon>
                  </button>
                </div>
                <div className="text-center">
                  <p className="mb-1">Don’t Have An Account?</p>
                  <a href="#" className="text-primary open-signup">Create Account Now</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>


        
        <nav className="navbar navbar-expand-lg navbar-light bg-white shadow-sm sticky-top" style={{ zIndex: 4 }}>
          <div className="container-fluid flex-column p-0">

            {/* Top Row: Logo + Welcome */}
            <div className="w-100 d-flex justify-content-between align-items-center px-3 py-2" style={{ backgroundColor: "#ffffff" }}>
              {/* Logo */}
              <a className="navbar-brand d-flex align-items-center" href="/">
                <img src={mmxlogo} style={{ height: "50px" }} alt="Logo" />
              </a>

              {/* Right side: login or user dropdown */}
              <ul className="navbar-nav ms-auto align-items-center flex-row">
                {!isLoggedIn && (
                  <li className="nav-item me-2">
                    <button
                      className="btn px-4 rounded-pill btngreentheme fw-bold"
                      onClick={() =>
                        UserService.doLogin({
                          redirectUri: `${REACT_APP_REDIRECT_URI}/dashboard`,
                        })
                      }
                    >
                      Login <i className="fas fa-sign-in-alt"></i>
                    </button>
                  </li>
                )}

                {isLoggedIn && (
                  <li className="nav-item dropdown ms-3">
                    <div
                      className="d-flex align-items-center dropdown-toggle"
                      data-bs-toggle="dropdown"
                      role="button"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="36"
                        height="36"
                        viewBox="0 0 23 23"
                        fill="#0d0d0dff"
                      >
                        <path d="M15.71 12.71a6 6 0 1 0-7.42 0a10 10 0 0 0-6.22 8.18a1 1 0 0 0 2 .22a8 8 0 0 1 15.9 0a1 1 0 0 0 1 .89h.11a1 1 0 0 0 .88-1.1a10 10 0 0 0-6.25-8.19M12 12a4 4 0 1 1 4-4a4 4 0 0 1-4 4"></path>
                      </svg>
                      <div className="ms-2 text-dark">
                        <div className="fw-bold">Welcome to Revenue Radar</div>
                        <div className="fw-medium">{username}</div>
                      </div>
                    </div>
                    <ul className="dropdown-menu dropdown-menu-end mt-2">
                      <li>
                        <button
                          className="dropdown-item text-dark"
                          onClick={() => {
                            UserService.doLogout({
                              redirectUri: `${REACT_APP_REDIRECT_URI}`,
                            });
                          }}
                        >
                          Logout <i className="fas fa-sign-out-alt"></i>
                        </button>
                      </li>
                    </ul>
                  </li>
                )}
              </ul>
              {/* Toggler (for row 2) */}
              <button
                className="navbar-toggler mx-2"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navbarContent"
                aria-controls="navbarContent"
                aria-expanded="false"
                aria-label="Toggle navigation"
              >
                <span className="navbar-toggler-icon"></span>
              </button>
            </div>

            {/* Bottom Row: Navigation Links (Collapsible) */}
            {UserService.isLoggedIn() && <div className="card w-100" style={{ backgroundColor: "#e6e7e8ff" }}>
              <div className="collapse navbar-collapse justify-content-start py-2" id="navbarContent">
                <ul className="navbar-nav mx-auto d-flex flex-wrap justify-content-start gap-3 mb-2">
                  {isLoggedIn &&
                    navItems.map(({ to, labelTop, labelBottom }, index) => (
                      <li className="nav-item dropdown text-center" key={to}>
                        <Link
                          className={`nav-link text-dark px-2 py-1 position-relative ${isActive(to) ? "fw-bold active-nav" : "fw-semibold"
                            }`}
                          to={to}
                          // onClick={() => checkToLink(to, index)}
                          style={{ fontSize: "16px", lineHeight: "1.2" }}
                        >
                          {labelTop}
                          {isActive(to) && (
                            <span
                              className="position-absolute top-100 start-50 translate-middle mt-1"
                              style={{
                                width: "100%",
                                height: "3px",
                                backgroundColor: "#107710",
                                // borderRadius: "50%",
                                // animation: "pulse 1.5s infinite",
                              }}
                            ></span>
                          )}
                        </Link>

                        {/* Dropdown */}
                        {/* {showBrandOption &&
                        to !== "/dashboard" &&
                        to !== "/modelperformance" &&
                        to !== "/savedreports" &&
                        to !== "/refreshmodel" &&
                        index === currentIndex && (
                          <ul
                            className="dropdown-menu show custom-dropdown text-center"
                            style={{ zIndex: 500, minWidth: "150px" }}
                          >
                            <li>
                              <button
                                className="dropdown-item brand-option"
                                onClick={() => handleBrandOptionToLink(to, "other")}
                              >
                                <strong>BI | SX | ND</strong>
                              </button>
                            </li>
                            <li>
                              <button
                                className="dropdown-item brand-option"
                                onClick={() => handleBrandOptionToLink(to, "atta")}
                              >
                                <strong>ATTA</strong>
                              </button>
                            </li>
                          </ul>
                        )} */}
                      </li>
                    ))}
                </ul>
              </div>
            </div>}
          </div>
        </nav>




      <style>
        {`
          @keyframes pulse {
            0% { transform: scale(1); opacity: 1; }
            50% { transform: scale(1.5); opacity: 0.5; }
            100% { transform: scale(1); opacity: 1; }
          }
          .active-nav {
            color: #0A4742 !important;
          }
        `}
      </style>
    </>
  );
}

export default Navbar3;
